export default {
  en: {
    'components.login-form.email.label': 'Email address',
    'components.login-form.email.placeholder': 'Enter email address',
    'components.login-form.email.required': 'Please enter an email address',
    'components.login-form.email.invalid': 'Please enter a valid email address',

    'components.login-form.password.label': 'Password',
    'components.login-form.password.placeholder': 'Enter password',
    'components.login-form.password.required': 'Please enter a password',
    'components.login-form.password.invalid': 'Password invalid',

    'components.login-form.action.continue': 'Continue',
    'components.login-form.action.signup': 'Sign Up',
    'components.login-form.action.forgot-password': 'Forgot Password?',

    'components.login-form.response.failure': 'Login request failed.',
  },
};
